export function formatTitleCaseLabel(value = '') {
  return String(value || '')
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/\b\w/g, (letter) => letter.toUpperCase());
}

const CARE_LABELS = {
  booking: { en: 'Bookings', fr: 'Reservations' },
  follow_up: { en: 'Follow-up', fr: 'Suivi' },
  profile_updates: { en: 'Profile updates', fr: 'Mises a jour du profil' },
  reminders: { en: 'Reminders', fr: 'Rappels' },
  family_member: { en: 'Family member', fr: 'Membre de la famille' },
  caregiver: { en: 'Caregiver', fr: 'Proche aidant' },
  parent: { en: 'Parent', fr: 'Parent' },
  guardian: { en: 'Guardian', fr: 'Tuteur' },
  active: { en: 'Active', fr: 'Actif' },
  revoked: { en: 'Revoked', fr: 'Revoque' },
  pending: { en: 'Pending', fr: 'En attente' },
  notified: { en: 'Notified', fr: 'Notifie' },
  accepted: { en: 'Accepted', fr: 'Accepte' },
  cancelled: { en: 'Cancelled', fr: 'Annule' },
  confirmed: { en: 'Confirmed', fr: 'Confirme' },
  completed: { en: 'Completed', fr: 'Termine' },
  in_progress: { en: 'In progress', fr: 'En cours' },
  paid: { en: 'Paid', fr: 'Paye' },
  failed: { en: 'Failed', fr: 'Echoue' },
  draft: { en: 'Pending', fr: 'En attente' },
  self: { en: 'My care', fr: 'Mes soins' },
  delegate: { en: 'Delegate access', fr: 'Acces delegue' },
  provider_observation: { en: 'Provider observation', fr: 'Observation du prestataire' },
  caregiver_observation: { en: 'Caregiver observation', fr: 'Observation du proche aidant' },
  symptom_log: { en: 'Symptom log', fr: 'Journal des symptomes' },
  milestone: { en: 'Milestone check-in', fr: 'Point de suivi du jalon' },
  symptom: { en: 'Symptom', fr: 'Symptome' },
  mobility: { en: 'Mobility', fr: 'Mobilite' },
  behavior: { en: 'Behaviour', fr: 'Comportement' },
  wound: { en: 'Wound or skin concern', fr: 'Plaie ou probleme cutane' },
  low: { en: 'Low priority', fr: 'Priorite basse' },
  medium: { en: 'Medium priority', fr: 'Priorite moyenne' },
  high: { en: 'High priority', fr: 'Priorite elevee' },
  patient_family: { en: 'Patient or family feedback', fr: 'Commentaires du patient ou de la famille' },
  provider_platform: { en: 'Provider platform feedback', fr: 'Commentaires du prestataire sur la plateforme' },
  care_outcome: { en: 'Care outcome reflection', fr: 'Bilan de resultat de soins' }
};

export function formatCareLabel(value, language = 'en') {
  const normalized = String(value || '').trim().toLowerCase();
  const dictionary = CARE_LABELS[normalized];
  if (dictionary) return dictionary[language] || dictionary.en;
  return formatTitleCaseLabel(value);
}
